<template>
  <vv-screen-wrapper>
    <div class="screen-container">
      <!-- Instructions -->
      <vv-box :title="title" v-if="question && question.instruction">
        <vv-rich-text :document="question.instruction" />
      </vv-box>

      <!-- Image -->
      <div class="image" v-if="question && question.image">
        <img :src="question.image.fields.file.url" />
      </div>

      <!-- Question -->
      <div class="question" v-if="question && question.data && question.data.question">{{ question.data.question }}</div>

      <!-- Answer -->
      <tasting-answer :question="question" v-model="value" @status="handleStatus" />

      <div class="cta">
        <vv-button @click="validate" id="next">{{ $t('tasting.question.button') }}</vv-button>
      </div>
    </div>
  </vv-screen-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import get from 'lodash/get'

import { SUBMIT_TASTING_ANSWER } from '@/store/modules/tasting/types'
import { REGISTER_COMPLETION } from '@/store/modules/completion/types'
import { VvButton, VvBox, VvRichText, VvScreenWrapper } from '@/components/common'
import TastingAnswer from '@/components/tasting/TastingAnswer'

export default {
  name: 'TastingQuestion',
  components: { TastingAnswer, VvButton, VvBox, VvRichText, VvScreenWrapper },
  data() {
    return {
      value: null,
      correct: false
    }
  },
  mounted() {
    // Initialization from store response
    if (this.answer) {
      this.value = this.answer
    }
  },
  computed: {
    ...mapGetters({
      section: 'currentSection',
      question: 'currentTastingQuestion',
      answerId: 'currentTastingAnswerId',
      answer: 'currentTastingAnswer'
    }),
    title() {
      const sectionId = get(this.$router.currentRoute.params, 'sectionId')

      if (!sectionId) return null

      return this.$t(`tasting.section.${sectionId}.title`)
    }
  },
  methods: {
    handleStatus(correct) {
      this.correct = correct
    },
    validate() {
      if (this.value === null) return

      this.$store.dispatch(SUBMIT_TASTING_ANSWER, {
        value: this.value,
        answerId: this.answerId,
        correct: this.correct || false
      })

      this.$store.dispatch(REGISTER_COMPLETION, {
        contentType: 'tasting-question',
        id: this.question.id,
        status: { complete: true, answerId: this.answerId, correct: this.correct || false }
      })

      this.value = null
    }
  }
}
</script>

<style lang="scss" scoped>
.image {
  margin-top: 30px;
  text-align: center;

  img {
    width: 50%;
  }
}

.question {
  margin-top: 30px;
  text-align: center;
}
</style>
